import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {
	DataCollectionStatus,
	MetricAverage,
	Server,
	ServerAgent
} from "../../../../../../services/model/server.model";
import {TendencyWidgetContent} from "../../../../../global/application-mini-widget/application-mini-widget.component";
import {finalize, forkJoin, Observable, of, Subscription, switchMap, tap} from "rxjs";
import {ServerDetailData, ServerDetailService} from "../../../../../../services/front/server-detail.service";
import {ServerUrlService} from "../../../../../../services/front/server-url.service";
import {ServerService} from "../../../../../../services/back/server.service";
import {QueryRangeType} from "../../../../../../services/back/tenant-finance.service";

@Component({
	selector: 'app-server-overview-tab',
	standalone: false,
	templateUrl: './server-overview-tab.component.html',
	styleUrl: './server-overview-tab.component.scss'
})
export class ServerOverviewTabComponent implements OnInit, OnDestroy {
	@Input() tabActive: boolean;

	tenantId: string;
	isEditor: boolean;
	server: Server;
	isTenantInactivePlan: boolean;

	_initializing: boolean;
	_loading: boolean;
	initialized: boolean = false;

	loadWidget: TendencyWidgetContent | undefined;
	storageWidget: TendencyWidgetContent | undefined;
	agent: ServerAgent;

	subscription: Subscription = new Subscription();

	constructor(private serverDetailService: ServerDetailService,
				private serverService: ServerService) {
	}

	ngOnInit() {
		this.subscription.add(this.serverDetailService.getInitializingChanges()
			.subscribe(initializing => this._initializing = initializing));
		this.subscription.add(this.serverDetailService.getServerDetailDataChanges()
			.pipe(tap(data => this.setServerDetailData(data)))
			.subscribe(() => this.initialize()));
	}

	private setServerDetailData(data: ServerDetailData): void {
		this.tenantId = data.tenantId;
		this.isEditor = data.isEditor;
		this.server = data.server;
		this.isTenantInactivePlan = data.isInactivePlan;
	}

	initialize(): void {
		this.subscription.add(this.switchLoading()
			.pipe(
				switchMap(() => forkJoin([
					this.server.automatic ? this.serverService.getServerAgent(this.tenantId, this.server.id) : of(null),
					this.server.automatic ? this.serverService.getServerMetricAverage(this.tenantId, this.server.id) : of(null)
				])),
				tap(([agent, metrics]) => this.setWidgetData(agent, metrics)),
				finalize(() => this.switchLoading()))
			.subscribe(() => this.initialized = true));

	}

	setWidgetData(agent: ServerAgent | null, metrics: MetricAverage | null): void {
		if (agent)
			this.agent = agent;

		this.loadWidget = {
			value: metrics?.load,
			day: QueryRangeType.PAST_1_MONTH,
		};

		this.storageWidget = {
			value: metrics?.storage,
			day: QueryRangeType.PAST_1_MONTH,
		};
	}

	formattedDate(date: string) {
		return date.substring(8, 10) + '/' + date.substring(5, 7) + '/' + date.substring(0, 4);
	}

	private switchLoading(): Observable<{}> {
		this._loading = !this._loading;
		return of({});
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	protected readonly DataCollectionStatus = DataCollectionStatus;
}
